import { render, staticRenderFns } from "./AccepterMainMenu.vue?vue&type=template&id=34c0c501&"
import script from "./AccepterMainMenu.vue?vue&type=script&lang=ts&"
export * from "./AccepterMainMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports